import fw_request from '../utils/fw-request'
import oa_request from '../utils/oa-request'
import request from '../utils/request'
import Vue from 'vue';

//获取待办下拉列表
export function todeselect(data) {
    return request({
        url: '/v2/msg/remind/selOption',
        method: 'get',
        params: data
    })
}

//获取代办事件列表
export function todolist(data) {
    return request({
        url: '/v2/msg/remind/list',
        method: 'get',
        params: data
    })
}

//获取代办事件列表(无分页)
export function noPageList(data) {
    return request({
        url: 'v2/msg/remind/noPageList',
        method: 'get',
        params: data
    })
}

//系统消息消息列表
export function msglist(data) {
    return request({
        url: '/v2/msg/msg/msgList',
        method: 'get',
        params: data
    })
}

//系统消息查询列表
export function msgselect(data) {
    return request({
        url: '/v2/msg/msg/option',
        method: 'get',
        params: data
    })
}


//获取公告列表-发出的
export function noticelist(data) {
    return request({
        // url:'/v2/msg/notice/list',
        url: '/v3/notice/list',
        method: 'get',
        params: data
    })
}

//获取公告列表-收到的
export function receiveList(data) {
    return request({
        // url:'/v2/msg/notice/list',
        url: '/v3/notice/receiveList',
        method: 'get',
        params: data
    })
}

//添加系统公告
export function addnotice(data) {
    return request({
        // url:'/v2/msg/notice/create',
        url: '/v3/notice/add',
        method: 'post',
        data
    })
}

//公告详情
export function noticedetail(data) {
    return request({
        // url:'/v2/msg/notice/detail',
        url: '/v3/notice/detail',
        method: 'get',
        params: data
    })
}
//编辑公告
export function editdetail(data) {
    return request({
        // url:'/v2/msg/notice/edit',
        url: '/v3/notice/edit',
        method: 'post',
        data
    })
}

//我收到的列表删除
export function receiveDel(data) {
    return request({
        url: '/v3/notice/receiveDel',
        method: 'post',
        data
    })
}

//已发出列表的删除
export function sendDel(data) {
    return request({
        url: '/v3/notice/sendDel',
        method: 'post',
        data
    })
}

//撤回
export function withdraw(data) {
    return request({
        url: '/v3/notice/withdraw',
        method: 'post',
        data
    })
}

// 获取公告读取详情
export function readdetail(data) {
    return request({
        url: '/v2/msg/notice/check',
        method: 'get',
        params: data
    })
}

//查询当前登录人所有未查看的公告
export function notRead(data) {
    return request({
        url: '/v3/notice/notRead',
        method: 'get',
        params: data
    })
}

// 记录已读公告
export function readRecord(data) {
    return request({
        url: '/v3/notice/readRecord',
        method: 'post',
        data
    })
}
//系统消息模版列表
export function modellist(data) {
    return request({
        url: '/v2/msg/msg/temList',
        method: 'get',
        params: data
    })
}

//系统消息-部门
export function branchAndAdmin(data) {
    return request({
        url: '/v3/notice/branchAndAdmin',
        method: 'get',
        params: data
    })
}

//更改模版状态
export function changestatus(data) {
    return request({
        url: '/v2/msg/msg/temStatus',
        method: 'post',
        data
    })
}

//模板详情
export function modeldetail(data) {
    return request({
        url: '/v2/msg/msg/temDetail',
        method: 'get',
        params: data
    })
}

//编辑模版
export function editmodel(data) {
    return request({
        url: '/v2/msg/msg/temEdit',
        method: 'post',
        data
    })
}



//系统消息模版列表
export function modellist_fw(data) {
    return fw_request({
        url: '/back/v1/template/index',
        method: 'get',
        params: data
    })
}

//系统消息消息列表
export function msglist_fw(data) {
    return fw_request({
        url: '/back/v1/system/index',
        method: 'get',
        params: data
    })
}
//获取代办事件列表
export function todolist_fw(data) {
    return fw_request({
        url: '/back/v1/remind/index',
        method: 'get',
        params: data
    })
}
//更改模版状态
export function changestatus_fw(data) {
    return fw_request({
        url: '/back/v1/template/status',
        method: 'post',
        data
    })
}

//模板详情
export function modeldetail_fw(data) {
    return fw_request({
        url: '/back/v1/template/detail',
        method: 'get',
        params: data
    })
}

//编辑模版
export function editmodel_fw(data) {
    return fw_request({
        url: '/back/v1/template/edit',
        method: 'post',
        data
    })
}

//获取待办下拉列表
export function todeselect_fw(data) {
    return fw_request({
        url: '/back/v1/remind/option',
        method: 'get',
        params: data
    })
}


//获取待办下拉列表
export function batchDelMsg(data) {
    return request({
        url: '/v3/msg/batchDelMsg',
        method: 'post',
        params: data
    })
}


//代办 删除
export function delRemind(data) {
    return request({
        url: '/v3/msg/delRemind',
        method: 'post',
        params: data
    })
}

//代办 批量删除提醒 
export function batchDelRemind(data) {
    return request({
        url: '/v3/msg/batchDelRemind',
        method: 'post',
        params: data
    })
}

//定时发送
export function sendNotice(data){
    return oa_request({
        url:`${Vue.prototype.$BASE_EXPORT_URL}/v1/notice/sendNotice`,
        method:'get',
        params:data
    })
}